import sign from 'tm2sign.macro';
import { userForDisplayFields } from 'utils/gql/common-fields';

export default {
  currenciesFields: sign('currencies', ['id', 'code', 'order']),
  userForDisplayFields: sign('usersByRole', [...userForDisplayFields, { issuerInvestor: ['id'] }]),
};
